import { render, staticRenderFns } from "./MarketingSmsEdit.vue?vue&type=template&id=7352a9c5&scoped=true"
import script from "./MarketingSmsEdit.vue?vue&type=script&lang=js"
export * from "./MarketingSmsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352a9c5",
  null
  
)

export default component.exports